import { useState } from 'react';
import { Plus, Download, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { exportClientsToExcel } from '../../../utils/exportClients';

export default function ClientsHeader({ clients = [], canCreateClient = true }) {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = () => {
        if (!clients || clients.length === 0) {
            return;
        }
        
        setIsExporting(true);
        
        // Small delay to show loading state
        setTimeout(() => {
            try {
                exportClientsToExcel(clients);
            } catch (error) {
                console.error('Export failed:', error);
            } finally {
                setIsExporting(false);
            }
        }, 100);
    };

    return (
        <div className="flex items-center justify-between mb-3">
            <div>
                <h1 className="text-xl font-bold text-gray-900">Clients</h1>
                <p className="text-xs text-gray-600">Manage clients & leads</p>
            </div>

            <div className="flex items-center gap-2">
                <button
                    onClick={handleExport}
                    disabled={isExporting || clients.length === 0}
                    className="px-3 py-2 border border-gray-300 rounded-lg text-xs font-medium flex items-center gap-1.5 bg-white shadow-sm hover:bg-gray-50 disabled:opacity-70 transition"
                >
                    {isExporting ? (
                        <>
                            <Loader2 className="w-4 h-4 animate-spin text-gray-600" />
                            Exporting...
                        </>
                    ) : (
                        <>
                            <Download className="w-4 h-4 text-gray-600" />
                            Export to Excel
                        </>
                    )}
                </button>

                {canCreateClient && (
                    <Link
                        to="/profile/create/clients"
                        className="px-3 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg text-xs font-bold flex items-center gap-1.5 shadow-md hover:shadow-lg transition-shadow"
                    >
                        <Plus className="w-4 h-4" />
                        New Client
                    </Link>
                )}
            </div>
        </div>
    );
}